import { Center, Spinner } from '@chakra-ui/react';
import EventGridCarousel from 'presentation/components/modules/events/grid/EventGridCarousel';
import EventGridItem from 'presentation/components/modules/events/grid/EventGridItem';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchUpcomingEventsQuery } from 'rtkQuery/sharespro/queries/events';

const EventsAllUpcomingCarouselContainer: FC = () => {
  const { t } = useTranslation();

  const { data, isFetching, error, refetch } = useFetchUpcomingEventsQuery();

  let wrapByCard = true;
  let content;
  if (data) {
    if (data.items.length === 0) return null;
    if (data.items.length > 1) {
      content = <EventGridCarousel events={data.items} size="large" maxWidth="992px" />;
    } else {
      content = <EventGridItem data={data.items[0]} height={290} />;
    }
    wrapByCard = false;
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20px" h="290px">
        <Center h="100%">{content}</Center>
      </AppCard>
    );
  }

  return (
    <>
      <GridHeading>{t('upcomingEvents')}</GridHeading>
      {content}
    </>
  );
};

export default EventsAllUpcomingCarouselContainer;
